import { render } from "./JzFooter.vue?vue&type=template&id=9e23fbf4&scoped=true"
import script from "./JzFooter.vue?vue&type=script&lang=js"
export * from "./JzFooter.vue?vue&type=script&lang=js"

import "./JzFooter.vue?vue&type=style&index=0&id=9e23fbf4&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e23fbf4"]])

export default __exports__